/** Standart Ufuklar.tr geliştirici imzası (tüm sitelerde aynı). Kaynak: kunt-yapi/src/components/site/UfuklarSignature.tsx */
/** @param {{surface?: "light"|"dark", className?: string}} props */
export function UfuklarSignature({ surface = "light", className = "" }) {
  return (
    <a href="https://ufuklar.tr" aria-label="Ufuklar.tr" className={`ufsig ufsig--${surface} ${className}`}>
      <span className="ufsig__text">
        Ufuklar<span className="ufsig__dot">.</span>tr
      </span>
      <svg className="ufsig__arrow" viewBox="0 0 12 12" width="11" height="11" aria-hidden="true" focusable="false">
        <path d="M3 9 9 3M4.5 3H9v4.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <style>{`
        .ufsig { --ufsig-orange: #fc8b00; position: relative; display: inline-flex; align-items: center; gap: 0.3rem;
          padding: 0.25rem 0.125rem 0.45rem; overflow: hidden; font-family: inherit; font-size: 15px; font-weight: 600;
          letter-spacing: 0.02em; line-height: 1; text-decoration: none; border-radius: 2px; white-space: nowrap; }
        .ufsig--light { color: #202428; }
        .ufsig--dark { color: #f4f2ec; }
        .ufsig__dot { color: var(--ufsig-orange); }
        .ufsig::after { content: ""; position: absolute; left: 0.125rem; bottom: 0.2rem; height: 1.5px; width: 14px;
          background: var(--ufsig-orange); transition: width 350ms cubic-bezier(0.22, 1, 0.36, 1); }
        .ufsig::before { content: ""; position: absolute; inset: 0; pointer-events: none; transform: translateX(-120%);
          background: linear-gradient(100deg, transparent 20%, rgb(252 139 0 / 0.28) 50%, transparent 80%); }
        .ufsig__arrow { flex: none; transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1); }
        .ufsig:hover::after, .ufsig:focus-visible::after { width: calc(100% - 0.25rem); }
        .ufsig:hover::before, .ufsig:focus-visible::before { animation: ufsig-sweep 700ms ease-out 1; }
        .ufsig:hover .ufsig__arrow, .ufsig:focus-visible .ufsig__arrow { transform: translate(2px, -2px); }
        .ufsig:focus-visible { outline: 2px solid var(--ufsig-orange); outline-offset: 3px; }
        @keyframes ufsig-sweep { from { transform: translateX(-120%); } to { transform: translateX(120%); } }
        @media (prefers-reduced-motion: reduce) {
          .ufsig::after, .ufsig__arrow { transition: none; }
          .ufsig:hover::before, .ufsig:focus-visible::before { animation: none; }
          .ufsig:hover .ufsig__arrow, .ufsig:focus-visible .ufsig__arrow { transform: none; }
        }
      `}</style>
    </a>
  );
}
